var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEficiencia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.235,
    height: 54.176,
    viewBox: "0 0 72.235 54.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eficiencia",
    transform: "translate(-6.25 -17.188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9065",
    "data-name": "Path 9065",
    className: "cls-1",
    d: "M55.214,17.188a27.118,27.118,0,1,0,19.145,7.943,27.1,27.1,0,0,0-19.145-7.943Zm0,51.6A24.542,24.542,0,1,1,72.534,61.6a24.508,24.508,0,0,1-17.32,7.188Z",
    transform: "translate(-3.816)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9066",
    "data-name": "Path 9066",
    className: "cls-1",
    d: "M56.3,23.438a21.954,21.954,0,1,0,15.5,6.43,21.917,21.917,0,0,0-15.5-6.43Zm0,41.277A19.367,19.367,0,1,1,69.98,59.043,19.358,19.358,0,0,1,56.3,64.715Z",
    transform: "translate(-4.907 -1.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9067",
    "data-name": "Path 9067",
    className: "cls-1",
    d: "M70.44,45.167H63.752a3.862,3.862,0,0,0-2.341-2.341V30.978a1.29,1.29,0,1,0-2.58,0V42.826a3.86,3.86,0,1,0,4.921,4.921H70.44a1.29,1.29,0,0,0,0-2.58ZM60.12,47.747a1.291,1.291,0,1,1,1.29-1.29,1.289,1.289,0,0,1-1.29,1.29Z",
    transform: "translate(-8.723 -2.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9068",
    "data-name": "Path 9068",
    className: "cls-1",
    d: "M21.729,49.727a1.288,1.288,0,0,0-1.29-1.29H7.54a1.29,1.29,0,0,0,0,2.58h12.9a1.288,1.288,0,0,0,1.29-1.29Z",
    transform: "translate(0 -5.452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9069",
    "data-name": "Path 9069",
    className: "cls-1",
    d: "M12.227,41.643h10.01a1.29,1.29,0,0,0,0-2.58H12.227a1.29,1.29,0,1,0,0,2.58Z",
    transform: "translate(-0.818 -3.816)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9070",
    "data-name": "Path 9070",
    className: "cls-1",
    d: "M16.915,32.267h9.326a1.29,1.29,0,1,0,0-2.58H16.915a1.29,1.29,0,1,0,0,2.58Z",
    transform: "translate(-1.636 -2.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9071",
    "data-name": "Path 9071",
    className: "cls-1",
    d: "M26.289,22.893h7.933a1.29,1.29,0,1,0,0-2.58H26.289a1.29,1.29,0,1,0,0,2.58Z",
    transform: "translate(-3.271 -0.545)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9072",
    "data-name": "Path 9072",
    className: "cls-1",
    d: "M23.055,57.812h-6.14a1.29,1.29,0,0,0,0,2.58h6.14a1.29,1.29,0,1,0,0-2.58Z",
    transform: "translate(-1.636 -7.087)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9073",
    "data-name": "Path 9073",
    className: "cls-1",
    d: "M26.713,68.477a1.288,1.288,0,0,0-1.29-1.29h-13.2a1.29,1.29,0,1,0,0,2.58h13.2a1.288,1.288,0,0,0,1.29-1.29Z",
    transform: "translate(-0.818 -8.723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9074",
    "data-name": "Path 9074",
    className: "cls-1",
    d: "M34.223,76.562H26.29a1.29,1.29,0,0,0,0,2.58h7.933a1.29,1.29,0,1,0,0-2.58Z",
    transform: "translate(-3.271 -10.358)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEficiencia);
export default __webpack_public_path__ + "static/media/Eficiencia.e6f2bfa66718e614668db404305f1973.svg";
export { ForwardRef as ReactComponent };